// @flow
const CHANNEL_NAME = 'auth_sync_channel';

class AuthSyncChannel {
  channel: BroadcastChannel;

  listeners: Map<string, Array<Function>>;

  constructor() {
    this.listeners = new Map();
    this.channel = new BroadcastChannel(CHANNEL_NAME);
    this.channel.onmessage = (event: any) => {
      this.handleMessage(event.data);
    };
  }

  handleMessage(data: { type: string, payload: any }) {
    const listeners = this.listeners.get(data.type) || [];
    listeners.forEach((callback) => callback(data.payload));
  }

  postMessage(type: string, payload: any) {
    const message = { type, payload };

    if (this.channel) {
      this.channel.postMessage(message);
    }
  }

  subscribe(type: string, callback: Function) {
    if (!this.listeners.has(type)) {
      this.listeners.set(type, []);
    }

    const callbacks = this.listeners.get(type);
    if (callbacks) {
      callbacks.push(callback);
    }

    return () => {
      const listeners = this.listeners.get(type);
      if (listeners) {
        const index = listeners.indexOf(callback);
        if (index > -1) {
          listeners.splice(index, 1);
        }
      }
    };
  }

  close() {
    if (this.channel) {
      this.channel.close();
    }
  }
}

let syncChannel: ?AuthSyncChannel = null;

export const getAuthSyncChannel = (): AuthSyncChannel => {
  if (!syncChannel) {
    syncChannel = new AuthSyncChannel();
  }
  return syncChannel;
};
